import React from 'react';

export default function AppFooter() {
  return (
    <p className="text-center mt-3 mb-3 text-muted">
      <a
        href="https://www.moraes-tech.com/"
        target="_blank"
        rel="noopener noreferrer"
      >
        ©<b>MoraesTech</b>.
      </a>{' '}
      <a
        href="https://www.instagram.com/moraestech.br/"
        target="_blank"
        rel="noopener noreferrer"
      >
        v. 716 - 31/10/2026.
      </a>
    </p>
  );
}
